module.exports = __webpack_public_path__ + "img/swift-sport-2021.c3f29ab1.svg";